/* eslint-disable max-lines-per-function */
import { ErinnerungsZeiten } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/erinnerungsZeiten';
import { FristenGrund } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/fristenGrund';
import { Anstellungstyp } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/anstellungstyp';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import z from 'zod';

export function useAnstellungsverhaeltnisSchema() {
  const { t } = useTranslation();
  const anstellungSchema = z
    .object({
      anstellungstyp: z
        .string()
        .refine((value) => Object.keys(Anstellungstyp).includes(value), {
          error: t(
            'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.anstellungstyp.validationError',
          ),
        }),
      eintrittsdatum: z.iso
        .datetime()
        .optional()
        .refine(
          (value) => {
            return !!value;
          },
          {
            error: t(
              'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.eintrittsdatum.validationError',
            ),
          },
        ),
      befristet: z.boolean(),
      befristung: z.iso.datetime().optional(),
    })
    .superRefine((data, ctx) => {
      if (data.befristet) {
        if (!data.befristung) {
          ctx.addIssue({
            code: 'custom',
            message: t(
              'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.befristetBis.validationError',
            ),
            path: ['befristung'],
          });
        } else if (
          data.eintrittsdatum &&
          dayjs(data.befristung).isSameOrBefore(dayjs(data.eintrittsdatum))
        ) {
          ctx.addIssue({
            code: 'custom',
            message: t(
              'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.befristetBis.validationErrorBeforeEintrittsdatum',
            ),
            path: ['befristung'],
          });
        }
      }
    });

  const FristenSchema = z
    .object({
      fristdatum: z.iso
        .datetime()
        .optional()
        .refine(
          (value) => {
            return !!value;
          },
          {
            error: t(
              'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.fristdatum.validationError',
            ),
          },
        ),
      grund: z
        .string()
        .refine((value) => Object.keys(FristenGrund).includes(value), {
          error: t(
            'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.grund.validationError',
          ),
        }),
      bemerkung: z.string().max(250).optional(),
      erinnerung: z.boolean(),
      erinnerungsZeit: z
        .string()
        .array()
        .refine((value) => {
          return value.every((v) => Object.keys(ErinnerungsZeiten).includes(v));
        }),
      erinnerungAn: z.string().array(),
    })
    .superRefine((data, ctx) => {
      if (data.erinnerung) {
        if (data.erinnerungsZeit.length === 0) {
          ctx.addIssue({
            code: 'custom',
            message: t(
              'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.erinnerungsZeit.validationError',
            ),
            path: ['erinnerungsZeit'],
          });
        }
        if (data.erinnerungAn.length === 0) {
          ctx.addIssue({
            code: 'custom',
            message: t(
              'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.erinnerungAn.validationError',
            ),
            path: ['erinnerungAn'],
          });
        }
      }
    });

  return {
    FristenSchema,
    anstellungSchema,
  };
}
